import { BaseImage } from './base-image';
import { DragDropToken } from './drag-drop-token';

export class DragDropImage extends BaseImage {

	correctToken: DragDropToken;
	filledToken: DragDropToken;

}
